var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGPay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14105",
    "data-name": "Group 14105",
    transform: "translate(-237 -278)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_774",
    "data-name": "Rectangle 774",
    width: 47,
    height: 47,
    rx: 5,
    transform: "translate(237 278)",
    fill: "#f6f6f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Google_Pay__GPay__Logo",
    "data-name": "Google_Pay_(GPay)_Logo",
    transform: "translate(244.196 295.026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M191.3,15.57v3.8h-1.2V9.992h3.193a2.888,2.888,0,0,1,2.068.811,2.71,2.71,0,0,1,0,3.967,2.879,2.879,0,0,1-2.068.8H191.3Zm0-4.424v3.272h2.019a1.621,1.621,0,0,0,1.191-2.775,1.571,1.571,0,0,0-1.191-.5H191.3Z",
    transform: "translate(-175.883 -9.244)",
    fill: "#5f6368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M274.447,46.78a2.986,2.986,0,0,1,2.107.713,2.529,2.529,0,0,1,.772,1.956V53.4h-1.152v-.89h-.052a2.3,2.3,0,0,1-1.989,1.1,2.586,2.586,0,0,1-1.773-.628,2.006,2.006,0,0,1-.713-1.571,1.9,1.9,0,0,1,.752-1.583,3.181,3.181,0,0,1,2.009-.589,3.555,3.555,0,0,1,1.766.393v-.275a1.371,1.371,0,0,0-.5-1.066,1.705,1.705,0,0,0-1.162-.439,1.843,1.843,0,0,0-1.6.851l-1.06-.668A2.951,2.951,0,0,1,274.447,46.78Zm-1.558,4.659a.962.962,0,0,0,.4.785,1.469,1.469,0,0,0,.936.314,1.92,1.92,0,0,0,1.354-.562,1.759,1.759,0,0,0,.6-1.321,2.46,2.46,0,0,0-1.571-.449,2.036,2.036,0,0,0-1.223.354A1.055,1.055,0,0,0,272.889,51.439Z",
    transform: "translate(-251.331 -43.281)",
    fill: "#5f6368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M356.635,49.58l-4.021,9.24h-1.243l1.492-3.233L350.22,49.58h1.309l1.911,4.607h.026l1.858-4.607Z",
    transform: "translate(-324.029 -45.872)",
    fill: "#5f6368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M77.171,60.095A6.416,6.416,0,0,0,77.078,59H72v2.074h2.908a2.493,2.493,0,0,1-1.075,1.636v1.346h1.736A5.266,5.266,0,0,0,77.171,60.095Z",
    transform: "translate(-66.616 -54.587)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M12.481,90.134a5.153,5.153,0,0,0,3.569-1.3l-1.736-1.346A3.266,3.266,0,0,1,9.458,85.78H7.67v1.387a5.385,5.385,0,0,0,4.811,2.967Z",
    transform: "translate(-7.097 -79.364)",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M2.365,43.118a3.226,3.226,0,0,1,0-2.061V39.67H.577a5.385,5.385,0,0,0,0,4.836Z",
    transform: "translate(-0.003 -36.703)",
    fill: "#fbbc04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M12.482,2.127a2.923,2.923,0,0,1,2.066.808h0L16.085,1.4a5.174,5.174,0,0,0-3.6-1.4A5.385,5.385,0,0,0,7.671,2.962L9.459,4.35A3.221,3.221,0,0,1,12.482,2.127Z",
    transform: "translate(-7.098 0.005)",
    fill: "#ea4335"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGPay);
export default __webpack_public_path__ + "static/media/GPay.190ba68282fefd9583f7ee2b189ef6c6.svg";
export { ForwardRef as ReactComponent };